import React, { Component } from 'react';
import Head from 'next/head';

import SideMenu from '../components/SideMenu';
import MainHeader from '../components/MainHeader';
import Loading from '../components/Loading';
import { __ } from '../lib/I18n';

/**
 * @typedef {{
 *  pageTitle?: string,
 *  children?: JSX.Element,
 *  header?: import('../components/MainHeader').Header,
 *  className?: string,
 *  noHeader?: boolean,
 *  style?: React.CSSProperties,
 *  loading?: boolean,
 *  noSideMenu?: boolean,
 * }} Props
 * @extends {Component<Props>}
 */
export default class Main extends React.Component {
  /** @param {Props} props */
  constructor(props) {
    super(props);

    this.refPage = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => this.refPage.current?.focus(), 50);
  }

  render() {
    const {
      pageTitle, children, header, className = '', noHeader, style, loading, noSideMenu
    } = this.props;

    return (
      <div className="main-layout">
        <Head>
          <title>{pageTitle ? `${pageTitle} · ${__('Financeiro')}` : __('Financeiro')}</title>
        </Head>

        {!noSideMenu && <SideMenu />}

        <div className={`page ${noSideMenu ? 'no-side-menu' : ''}`} ref={this.refPage} tabIndex={-1}>
          {loading && <Loading width={40} height={40} style={{ height: '100vh' }} />}

          {!loading && [
            !noHeader && <MainHeader {...header} key="main-header" />,

            <div className={`content ${className} ${noHeader ? ' no-header' : ''}`} style={style} key="main-content">
              {children}
            </div>
          ]}
        </div>
      </div>
    );
  }
}
